export const PER_PAGE_OPTIONS = [25, 50, 100];

export const JOB_FIELD_DEFINITIONS = [
  {
    key: 'job_code',
    label: 'Job Code',
  },
  {
    key: 'hourly_rate',
    label: 'Hourly Rate (£/hr)',
    formatter: value => {
      if (value === null || value === undefined || value === '') {
        return '';
      }
      const pounds = value / 100;
      return `${pounds.toFixed(2)}`;
    },
  },
  {
    key: 'multiplier',
    label: 'Multiplier',
  },
  {
    key: 'actions',
    label: 'Actions',
    thClass: 'text-center',
    tdClass: 'text-center',
  },
];
